var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 27.6666C23.5 28.6791 22.6792 29.4999 21.6667 29.4999C20.6542 29.4999 19.8334 28.6791 19.8334 27.6666C19.8334 26.6541 20.6542 25.8333 21.6667 25.8333C22.6792 25.8333 23.5 26.6541 23.5 27.6666Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 27.6666C12.8333 28.6791 12.0125 29.4999 11 29.4999C9.98744 29.4999 9.16663 28.6791 9.16663 27.6666C9.16663 26.6541 9.98744 25.8333 11 25.8333C12.0125 25.8333 12.8333 26.6541 12.8333 27.6666Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95164 5.2941L6.95171 5.2941L6.95226 5.28561C6.98729 4.7426 6.81145 4.20763 6.43587 3.79628L6.43596 3.7962L6.4283 3.78818C6.05756 3.39977 5.54173 3.16675 4.98663 3.16675H2.66663C2.3961 3.16675 2.16663 2.93727 2.16663 2.66675C2.16663 2.39622 2.3961 2.16675 2.66663 2.16675H4.98663C5.80182 2.16675 6.60251 2.51774 7.17751 3.12413C7.52647 3.52027 7.75622 3.99974 7.87239 4.51089L7.96085 4.90008H8.35996H24.7466C26.8182 4.90008 28.3865 6.57538 28.2346 8.64346L28.2346 8.64446C28.2136 8.93823 27.9689 9.16675 27.6666 9.16675H7.25329C6.91019 9.16675 6.65711 8.88814 6.68483 8.56248L6.68497 8.56076L6.95164 5.2941Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3467 11.6667H6.89332C6.33332 11.6667 5.87999 12.0934 5.82666 12.6401L5.34666 18.4401C5.15999 20.7201 6.94666 22.6667 9.22666 22.6667H24.0533C26.0533 22.6667 27.8133 21.0267 27.96 19.0267L28.4 12.8001C28.4533 12.1867 27.9733 11.6667 27.3467 11.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.c8385b83dbc6496bf241d7857ef749b9.svg";
export { ForwardRef as ReactComponent };